//
//
//
//
//
//
//
//
//
//
//
//
//
import communicationList from "./communicationList.vue";
import emialList from "./emialList.vue";
import vipActivation from "./vipActivation.vue";
export default {
  name: "communication",
  components: {
    emialList: emialList,
    communicationList: communicationList,
    vipActivation: vipActivation
  },
  mixins: [],
  data: function data() {
    return {
      activeIndex: 'communicationList'
    };
  },
  created: function created() {},
  activated: function activated() {},
  methods: {
    handover: function handover(index) {
      this.activeIndex = index;
    }
  }
};